import { render, staticRenderFns } from "./AuthorizationRenewalModal.vue?vue&type=template&id=56be9b1e&scoped=true&"
import script from "./AuthorizationRenewalModal.vue?vue&type=script&lang=js&"
export * from "./AuthorizationRenewalModal.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationRenewalModal.vue?vue&type=style&index=0&id=56be9b1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56be9b1e",
  null
  
)

export default component.exports